import { wordlist as english } from "@scure/bip39/wordlists/english";

export const ENGLISH_WORDLIST: readonly string[] = english;

export function isInWordlist(word: string): boolean {
  return ENGLISH_WORDLIST.includes(word.toLowerCase().trim());
}

export function indexOfWord(word: string): number {
  return ENGLISH_WORDLIST.indexOf(word.toLowerCase().trim());
}
